module.exports = __webpack_public_path__ + "img/youtube.a5d02182.svg";